import { PowerSettingsNewOutlined } from "@mui/icons-material";
import { AppBar, Box, CircularProgress, Grid, IconButton, Link, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useAppCookies } from "../../../util/useAppCookies";
import { useDispatch, useSelector } from "react-redux";
import { ActionType } from "../../../store/ActionType";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useMobileView } from "../../../util/useMobileView";
import UserMenu from "./UserMenu";


const PRIVACY_LINKS = [
    {
        label: 'Kişisel Verilerin Korunması',
        href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/',
        title: 'Kişisel Verilerin Korunması',
    },
    {
        label: 'Çerez Politikası',
        href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/cerez-politikasi/',
        title: 'Çerez Politikası',
    },
    {
        label: 'Gizlilik Politikası',
        href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/gizlilik-politikasi/',
        title: 'Gizlilik Politikası',
    },
];



const AdayPageFooter = () => {
    return (<Box
        component="footer"
        borderTop="1px solid #CDC9C8"
        sx={{
            bgcolor: 'grey.50',
            color: '#53565A',
            fontFamily: "Open Sans, sans-serif",
            p: 2,
            maxHeight: '10vh'
        }}
    >
        <Grid container>
            <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ fontSize: 12 }}>
                    Securitas Türkiye İnsan Kaynakları
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                md={6}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                }}
            >
                <Typography variant="body2" sx={{ fontSize: 12 }}>
                    {PRIVACY_LINKS.map((link, idx) => (
                        <React.Fragment key={link.href}>
                            <Link
                                href={link.href}
                                target="_blank"
                                title={link.title}
                                underline="hover"
                                sx={{ color: '#798D9E', }}
                            >
                                {link.label}
                            </Link>
                            {idx < PRIVACY_LINKS.length - 1 && ' | '}
                        </React.Fragment>
                    ))}
                </Typography>
            </Grid>
        </Grid>
    </Box>);
}

const MenuItemLink = ({ label, to }) => {
    const history = useHistory();


    return (
        <Typography
            variant="body2"
            sx={{ color: "white", cursor: "pointer" }}
            onClick={() => history.push(to)}
        >
            {label}
        </Typography>
    );
};

const AdayPage = ({ menuAction, isLoading = false, children }) => {

    const { clearUser } = useAppCookies();
    const full = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const history = useHistory();

    const onLogout = () => {
        clearUser();

        dispatch({
            type: ActionType.LOGOUT
        });


        history.push('/ilanlar?tenant=' + full?.tenantKey);


    }

    // Define your menu items
    const menuItems = [
        // { label: "Ana Sayfa", to: "/" },
        { label: "İlanlar", to: "/ilanlar?tenant=" + full?.tenantKey },
        // { label: "Başvurularım", to: "/basvurularim" },
        //{ label: "Profil", to: "/profil" },
    ];


    const filterContent = (
        full.isLoggedIn &&
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            {menuItems.map((item) => (
                <MenuItemLink key={item.label} label={item.label} to={item.to} />
            ))}
            <Typography variant="body2" sx={{ color: "white", cursor: "default" }}>
                {full.user?.adSoyad}
            </Typography>
            <IconButton sx={{ color: "white" }} onClick={onLogout}>
                <PowerSettingsNewOutlined />
            </IconButton>
        </Box>

    )

    const MenuContext = (
        <UserMenu full={full} onLogout={onLogout} menuItems={menuItems} />
    )

    const { isMobile } = useMobileView(MenuContext);



    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <AppBar className="ilanapp" position="static">
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Logo Section */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {menuAction && <Box sx={{ pr: 3 }}>{menuAction}</Box>


                        }
                        <img
                            src="/sc-ua-logo-white-2.svg"
                            alt="Securitas"
                            style={{ height: "auto", maxHeight: '10vh', minWidth: '45vw', width: '30vw', maxWidth: '60vw' }}
                        />
                    </Box>

                    {/* Navigation Menu */}
                    {!isMobile && filterContent}
                    {(isMobile && MenuContext)}
                </Toolbar>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: 'background.default',
                    p: 0,
                }}
            >

                {isLoading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="90vh" // Full viewport height
                    >
                        <CircularProgress color="secondary" />
                    </Box>
                ) : (
                    children
                )}

            </Box>
            {/* Footer / Trailer */}
            <AdayPageFooter />
        </Box>

    );
};

export default AdayPage;
